function PortalIcon({ size = 40 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#0a0a0a"
      strokeWidth="2.5"
    >
      <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M5 17h-2v-6l2-5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6-6h15m-6 0v-5" />
    </svg>
  );
}

export default function LoginModal({
  email,
  password,
  loginError,
  saveState,
  darkGray,
  danger,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  onCancel,
}) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.7)",
        backdropFilter: "blur(10px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        className="card"
        style={{
          padding: "40px",
          width: "100%",
          maxWidth: "420px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "82px",
            height: "82px",
            background: "linear-gradient(135deg, #00d4aa 0%, #00a8cc 100%)",
            borderRadius: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 24px",
            boxShadow: "0 8px 30px rgba(0, 212, 170, 0.3)",
          }}
        >
          <PortalIcon size={40} />
        </div>
        <h2
          style={{
            margin: "0 0 8px",
            fontFamily: "'Space Grotesk', sans-serif",
            fontSize: "34px",
            fontWeight: "700",
          }}
        >
          <span className="glow">Kjøretøyportal</span>
        </h2>
        <p style={{ margin: "0 0 28px", color: darkGray }}>
          Logg inn med din e-postadresse
        </p>
        <input
          type="email"
          placeholder="din@epost.no"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          className="inp"
          disabled={saveState.active}
          style={{ marginBottom: "12px" }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !saveState.active) {
              onSubmit();
            }
          }}
        />
        <input
          type="password"
          placeholder="Passord"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          className="inp"
          disabled={saveState.active}
          style={{ marginBottom: "18px" }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !saveState.active) {
              onSubmit();
            }
          }}
        />
        {loginError && (
          <p style={{ color: danger, marginTop: "0", marginBottom: "16px" }}>
            {loginError}
          </p>
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <button
            onClick={onSubmit}
            className="btn-p"
            disabled={saveState.active}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              width: "100%",
              opacity: saveState.active ? 0.8 : 1,
              cursor: saveState.active ? "not-allowed" : "pointer",
            }}
          >
            {saveState.active && (
              <span
                className="spinner"
                style={{ width: "16px", height: "16px", borderWidth: "2px", borderTopColor: "#0a0a0a" }}
              />
            )}
            {saveState.active ? "Logger inn..." : "Logg inn"}
          </button>
          <button
            onClick={onCancel}
            className="btn-s"
            disabled={saveState.active}
            style={{
              ...(saveState.active
                ? { opacity: 0.6, cursor: "not-allowed" }
                : null),
            }}
          >
            Avbryt
          </button>
        </div>
        <p
          style={{
            marginTop: "20px",
            fontSize: "13px",
            color: darkGray,
          }}
        >
          Bruk kontoen din for å få tilgang til kjøretøydata.
        </p>
      </div>
    </div>
  );
}
